import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import * as moment from 'moment';
import { stringify } from 'querystring';
import { ContactUserServicesDialogComponent } from 'src/app/dialogs/contact/contact-user-services-dialog/contact-user-services-dialog.component';
import { LaboDialogComponent } from 'src/app/dialogs/labo/labo-dialog/labo-dialog.component';
import { PatientDialogComponent } from 'src/app/dialogs/patient-dialog/patient-dialog.component';
import { PatientEidDialogComponent } from 'src/app/dialogs/patient/patient-eid-dialog/patient-eid-dialog.component';
import { ProtocolDialogComponent } from 'src/app/dialogs/protocol/protocol-dialog/protocol-dialog.component';
import { SmsConversationDialogComponent } from 'src/app/dialogs/sms/sms-conversation-dialog/sms-conversation-dialog.component';
import { Eid } from 'src/app/models/eid';
import { BecareService } from 'src/app/services/becare.service';
import { ODBService } from 'src/app/services/odb.service';
import { PatientService, PatientSearchResult } from 'src/app/services/patient.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { WampService } from 'src/app/services/wamp.service';

declare var Ext: any;
declare let Zone: any;

@Component({
  selector: 'app-patientsearch',
  templateUrl: './patientsearch.component.html',
  styleUrls: ['./patientsearch.component.scss']
})
export class PatientsearchComponent implements OnInit {

  public showNewPatient = false;
  public patientsearchvalue: string;
  public searchresults: PatientSearchResult[];
  public fromCardId = false;
  public cardInfo: Eid;
  public cardInfoHaveDifferences = false;
  private eiddialogopened = false;

  @ViewChild('dropdown') dropdown;

  constructor(public patientService: PatientService, public userConfig: UserConfigService,
              private typeManager: TypeManagerService, private dialog: MatDialog,
              private wamp: WampService, private becare: BecareService,
              private odb: ODBService) { }

  ngOnInit(): void {
    this.becare.authStatus().subscribe(status => {
        if (status === true) {
          console.log('authStatus', status);
          this.wamp.eidCardEvent.subscribe(event => {
            if (this.eiddialogopened === false) {
              this.eiddialogopened = true;
              const dialogConfig = new MatDialogConfig();
              dialogConfig.data = event;
              const dialogRef = this.dialog.open(PatientEidDialogComponent, dialogConfig);
              dialogRef.afterClosed().subscribe(result => {
                this.eiddialogopened = false;
                setTimeout(() => {
                    if (result instanceof Map) {
                        if (result.get('action') === 'search') {
                            this.patientService.search(result.get('search'))
                            .subscribe(patients => {
                                this.showNewPatient = true;
                                this.searchresults = patients;
                                this.dropdown.toggle(true);
                            }, error => {
                              console.log('Error while searching patients', error);
                            });
                        }
                        if (result.get('action') === 'select') {
                            this.patientClick(result.get('patient'));
                        }
                    }
                }, 200);
              });
            }
          });
        }
      });
  }

  searchPatient(event)
  {
      this.showNewPatient = false;
      this.fromCardId = false;
      this.patientService.search(this.patientsearchvalue)
          .subscribe(patients => {
              this.showNewPatient = true;
              this.searchresults = patients;
              this.dropdown.toggle(true);
          }, error => {
            console.log('Error while searching patients', error);
          });
  }

  createNewPatient()
  {
      let patientWindowParams: any = {
        patientdesc: this.patientsearchvalue
      };
      if (this.fromCardId) {
        patientWindowParams = {
            cardinfo: this.cardInfo
        };
      }
      const newPatientPanel = new Ext.CNPatientWindow(patientWindowParams);
      newPatientPanel.show();
      newPatientPanel.on('patientCreated', (newpatient) => {
          this.patientService.select(new PatientSearchResult(
              newpatient.id,
              newpatient.getProperty('Lastname'),
              newpatient.getProperty('Firstname'),
              newpatient.getProperty('Birthday'),
              newpatient.getProperty('Sex')
          ))
          .subscribe(result => {
              if (result.access === false)
              {
                  // No access for this patient, display alert with No Access
                  // TODO: Show Mandate dialog
                  // this.showPatientMandatePanel();
              }
          });
      }, this);
  }

//   showPatientMandatePanel()
//   {
//       let dialogRef = this.dialog.open(PatientMandateDialogComponent, {
//           data: { }
//       });
//       dialogRef.afterClosed().subscribe(result => {
//           console.log('The dialog was closed');
//       });
//   }

  patientSMS(patient)
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        patient
    };
    const dialogRef = this.dialog.open(SmsConversationDialogComponent, dialogConfig);

      // var thePatient = new Ext.CNPatient(patient.id);
      // thePatient.on('itemLoaded',function(item){
      //     getScope('SearchUserResultCtrl').showSendSmsPanel({
      //         patient:item.toObj()
      //     });
      // });
  }

  patientServices(patient)
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        patient,
        location: 'search'
    };
    const dialogRef = this.dialog.open(ContactUserServicesDialogComponent, dialogConfig);

      // var consultationWindow = new Ext.CNConsultationWindow({
      //     patientid:patient.id,
      //     displayconsult:false,
      //     displayservicecode:true,
      //     prestataireid:this.userConfig.userid,
      //     closewhensaved:true,
      //     displaybillbutton:true,
      //     source:'patientsearch'
      // });
      // consultationWindow.show();
  }

  patientCalendar(patient)
  {
      const selectedUser = new Ext.SNUser(patient.id);
      selectedUser.on('itemLoaded', (item) => {
          const agendaWindow = new Ext.CNUserAgendaWindow({
              displayappointments: true,
              user: item
          });
          agendaWindow.show();
      });
  }

  patientLab(patient)
  {
      // var patientLaboWindow = new Ext.CNLaboWindow({
      //     patientid:patient.id
      // });
      // patientLaboWindow.show();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
          patient,
          location: 'search'
      };
      const dialogRef = this.dialog.open(LaboDialogComponent, dialogConfig);
  }

  patientProtocol(patient)
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        patient,
        location: 'search'
    };
    const dialogRef = this.dialog.open(ProtocolDialogComponent, dialogConfig);
    // var patientProtocolsWindow = new Ext.CNProtocolsWindow({
      //     patientid:patient.id
      // });
      // patientProtocolsWindow.show();
  }

  patientAdmin(patient)
  {
      const thePatient = new Ext.CNPatient(patient.id);
      thePatient.on('itemLoaded', (item) => {
          const patientWindow = new Ext.CNPatientWindow({patient: item});
          patientWindow.show();
      });
  }

  patientClick(patient)
  {
      // if (this.showconsultationbutton === true)
      // {
      //     // Discard select new patient and show consultation dialog
      //     this.openWaitingConsultation();
      //     return;
      // }
      this.patientService.select(patient)
      .subscribe(result => {
          if (result.access === false)
          {
              // No access for this patient, display alert with No Access
              // TODO: Show Mandate dialog
              // this.showPatientMandatePanel();
          }
          if (result.access === true && typeof result.module !== 'undefined')
          {
              // // Load old module
              // let content = '/SN/StVaast/ajax.php?SelectModule=' + result.module.name + ',SelectFunction=' + result.module.function;
              // LoadContent(content);
          }
      });
  }

  openPatient(patient: PatientSearchResult) {
    this.odb.itemById(patient.id).subscribe(item => {
        // Open dialog
        const dialogRef = this.dialog.open(PatientDialogComponent, {
            data: {
                patient: item,
                cardinfo: this.cardInfo
            },
            maxWidth: '60%',
            minWidth: '480px'
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
          if (result === 'updateAndSelect') {
            item.setProperty('Firstname', this.cardInfo.firstname);
            item.setProperty('Lastname', this.cardInfo.lastname);
            item.setProperty('Birthday', moment(this.cardInfo.birthday).format('DD/MM/YYYY'));
            item.setProperty('NumSIS', this.cardInfo.niss);
            item.setProperty('NumIC', this.cardInfo.cardid);
            const itemUpdateSub = item.update().subscribe(updatedItem => {
                itemUpdateSub.unsubscribe();
                this.patientClick(patient);
            });
          }
        });
    });
  }

  toggleSearchReferring()
  {
      this.userConfig.userSearchOptions.searchreferring = !this.userConfig.userSearchOptions.searchreferring;
      this.searchPatient(undefined);
  }

  openCareTeam() {
    if (this.typeManager.typeMap('PatientCareTeamDialogComponent')) {
        const componentFactory = this.typeManager.typeMap('PatientCareTeamDialogComponent');
        const dialogRef = this.dialog.open(componentFactory, {
            data: {
            },
            maxWidth: '60%',
            minWidth: '480px'
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });
      }
  }

  searchCardId(cardInfo: Eid): void {
    this.showNewPatient = false;
    this.fromCardId = true;
    this.cardInfo = cardInfo;
    this.patientService.search(cardInfo.national_number)
        .subscribe(patients => {
            if (patients.length === 0) {
                // try with lastname and firstname
                const searchString = cardInfo.lastname + ' ' + cardInfo.firstname.split(' ')[0];
                this.patientService.search(searchString)
                    .subscribe(patientsOnName => {
                        if (patientsOnName.length === 0) {
                            // create patient
                            const newPatientPanel = new Ext.CNPatientWindow({
                                cardinfo: cardInfo
                            });
                            newPatientPanel.show();
                            newPatientPanel.on('patientCreated', (newpatient) => {
                                this.patientService.select(new PatientSearchResult(
                                    newpatient.id,
                                    newpatient.getProperty('Lastname'),
                                    newpatient.getProperty('Firstname'),
                                    newpatient.getProperty('Birthday'),
                                    newpatient.getProperty('Sex')
                                ))
                                .subscribe(result => {
                                    if (result.access === false)
                                    {
                                        // No access for this patient, display alert with No Access
                                        // TODO: Show Mandate dialog
                                        // this.showPatientMandatePanel();
                                    }
                                });
                            }, this);
                        } else {
                            // Check if the Card info are the same as the retreived one
                            this.cardInfoHaveDifferences = false;
                            patientsOnName.forEach(patient => {
                                if (patient.firstname.toLowerCase() !== cardInfo.firstnames.toLowerCase() ||
                                    patient.lastname.toLowerCase() !== cardInfo.surname.toLowerCase() ||
                                    patient.birthday !== moment(cardInfo.birthday).format('DD/MM/YYYY')) {
                                        this.cardInfoHaveDifferences = true;
                                    }
                            });
                            this.setSearchResult(patientsOnName);
                        }
                    });
            } else if (patients.length === 1) {
                // Wow, only one ...
                this.patientClick(patients[0]);
            } else {
                // Check if the Card info are the same as the retreived one
                this.cardInfoHaveDifferences = false;
                patients.forEach(patient => {
                    if (patient.firstname.toLowerCase() !== cardInfo.firstnames.toLowerCase() ||
                        patient.lastname.toLowerCase() !== cardInfo.surname.toLowerCase() ||
                        patient.birthday !== moment(cardInfo.birthday).format('DD/MM/YYYY')) {
                            this.cardInfoHaveDifferences = true;
                        }
                });
                this.setSearchResult(patients);
            }
        }, error => {
          console.log('Error while searching patients', error);
        });
  }

  setSearchResult(result: PatientSearchResult[]): void {
    this.showNewPatient = true;
    this.searchresults = result;
    this.dropdown.toggle(true);
  }
}
